export function getFullDate(dt1: string, dt2: string) {
  console.log(dt1, dt2, 'getFullDate - 1');
  let date = dt2.substring(0, dt2.indexOf('T')).trim();
  console.log(date, 'getFullDate - 2');
  let time = dt1.substring(dt1.indexOf('T')).trim();
  console.log(time, 'getFullDate - 3');
  let dateTime = date + time;
  console.log(dateTime, 'getFullDate - 4');
  // console.log(new Date(dateTime), 'getFullDate - 5');
  return dateTime;
}
